import { useQuery } from "@apollo/client";
import { RouteComponentProps } from "react-router";
import { FlexContainer } from "../../components/flex/Flex";
import { Spinner } from "../../components/Spinner";
import { ArticleCategoryView } from "./ArticleCategoryView";
import {
  ArticleCategoryViewQuery,
  ArticleCategoryViewResponse,
} from "./graphql";

type ArticleCategoryViewControllerProps = {} & RouteComponentProps<{
  id: string;
}>;

export const ArticleCategoryViewController = (
  props: ArticleCategoryViewControllerProps
) => {
  const match = props.match;
  let id = "";
  if (match && match.params.id && match.params.id.length > 0)
    id = match.params.id;

  const { loading, error, data, refetch } =
    useQuery<ArticleCategoryViewResponse>(ArticleCategoryViewQuery, {
      variables: { id },
    });

  if (loading) return <Spinner />;
  if (data && data.articleCategory !== null)
    return (
      <FlexContainer>
        <ArticleCategoryView
          articleCategory={data.articleCategory}
          refetch={() => refetch()}
        />
      </FlexContainer>
    );

  console.log("got error", error);

  return <p>Error!</p>;
};
